export default function checkedVal(func) {
  return function({ target }) {
    func(target?.checked);
  };
}
